

/* ———————————————————————————————————————————————————————————————————————————————— 
DEVICE 
Usage: 
loadVideoLazyDevice(`.png-{{ section.id }}`)
se usa para que se descargue solo el video relacionado al device en uso  
———————————————————————————————————————————————————————————————————————————————— */
function loadVideoLazyDevice(trigger){

  const containerTrigger = document.querySelector(trigger); 
  
  const mobileVideo = containerTrigger.querySelector('.hideOnDesktop');
  const desktopVideo = containerTrigger.querySelector('.hideOnMobile');

  function updateVideoSource() {
    if (window.innerWidth < 768) {
      
      const mobileSource = mobileVideo.querySelector('source');
      if (!mobileSource.getAttribute('src')) {      
        mobileSource.src = mobileSource.getAttribute('data-src');
        mobileVideo.load(); 
        mobileVideo.play(); 
      }
    } else {
      const desktopSource = desktopVideo.querySelector('source');
      if (!desktopSource.getAttribute('src')) {   
        desktopSource.src = desktopSource.getAttribute('data-src');
        desktopVideo.load();  
        desktopVideo.play();  
      }
    }
  }

  // Run on load
  updateVideoSource();

  // Run on resize
  window.addEventListener('resize', updateVideoSource);
}
 
 
